/**
 * The gift card form.
 *
 * Four small jobs, none of which Liquid can do: which amount is selected, the
 * customer's own timezone, how much of the message is left, and how far ahead
 * Shopify will let a card be scheduled.
 *
 * Everything it touches is inside the form, and if this file never loads the
 * page still sells a gift card — the first amount is checked server-side and
 * the recipient block simply stays closed. A gift card that cannot carry a
 * message is a worse gift card; one that cannot be bought is a lost sale.
 */
(function () {
  'use strict';

  var MAX_DAYS = 90; // Shopify will not schedule further out than this.

  function iso(date) {
    return date.toISOString().slice(0, 10);
  }

  function setup(form) {
    var idField = form.querySelector('[data-tc-gc-id]');
    var toggle = form.querySelector('[data-tc-gc-toggle]');
    var fields = form.querySelector('[data-tc-gc-fields]');
    var offset = form.querySelector('[data-tc-gc-offset]');
    var flag = form.querySelector('[data-tc-gc-flag]');
    var message = form.querySelector('[data-tc-gc-message]');
    var count = form.querySelector('[data-tc-gc-count]');
    var date = form.querySelector('[data-tc-gc-date]');

    var art = document.querySelector('.tc-gc__img');

    /* The amount, into the field the cart actually reads. The radios are named
       for themselves rather than "id" so the browser cannot submit two. */
    form.addEventListener('change', function (e) {
      if (!e.target.hasAttribute('data-tc-gc-amount')) return;
      if (idField) idField.value = e.target.value;

      /* And the card being looked at. srcset is cleared rather than rebuilt:
         it still describes the old picture at every width, and a browser is
         entitled to prefer it over the src we just set. */
      var img = e.target.getAttribute('data-tc-gc-img');
      if (img && art && art.tagName === 'IMG') {
        art.removeAttribute('srcset');
        art.src = img;
      }
    });

    /* Open, and only then submit. A disabled input sends nothing, which is how
       an unticked box sends no recipient at all rather than sending blanks —
       Shopify treats a present-but-empty Recipient email as an error. */
    function open(on) {
      if (fields) fields.hidden = !on;
      var owned = form.querySelectorAll('[data-tc-gc-input], [data-tc-gc-flag], [data-tc-gc-offset]');
      for (var i = 0; i < owned.length; i++) owned[i].disabled = !on;
      var email = form.querySelector('[name="properties[Recipient email]"]');
      if (email) email.required = !!on;
    }

    if (toggle) {
      toggle.addEventListener('change', function () {
        open(toggle.checked);
      });
      open(toggle.checked); // a browser-restored tick on a back-button return
    }

    /* Their calendar, not the shop's. getTimezoneOffset is minutes behind UTC,
       which is the sign Shopify documents, so it goes across as it comes. */
    if (offset) offset.value = String(new Date().getTimezoneOffset());

    if (date) {
      var today = new Date();
      var last = new Date(today.getTime() + MAX_DAYS * 86400000);
      date.min = iso(today);
      date.max = iso(last);
    }

    if (message && count) {
      var tally = function () {
        count.textContent = message.value.length + '/200';
      };
      message.addEventListener('input', tally);
      tally();
    }
  }

  function init() {
    /* The class rather than a data attribute: Liquid's form tag is fussy about
       hyphenated parameter names, and the class is already on it. */
    var forms = document.querySelectorAll('form.tc-gc__form');
    for (var i = 0; i < forms.length; i++) setup(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
